var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"accordion",staticClass:"accordion",class:{ expanded: _vm.expanded },on:{"toggle":_vm.onToggle}},[_c('div',{ref:"accordionInner"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }